import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { PageType } from '@app/courseContent/courseContent.component';
import { getUrlParams } from '@app/utils/url';
import { PlRouter } from '@shared/services/pl-router.service';
import { LocalStorageService } from '@shared/services/localStorage.service';
import { ParticipantService } from '@shared/services/participant/participant.service';
import { ParticipantGender } from '@shared/models/participant.model';
import { TOKEN_SURVEY_QUERY_PARAM_KEY } from '@shared/models/step.model';

export const ID_VIA_SURVEY_QUERY_PARAM_KEY: string = 'id' as const;
export const GENDER_VIA_SURVEY_QUERY_PARAM_KEY: string = 'g' as const;

@Component({
  selector: 'pl-via-survey-before-program',
  templateUrl: './viaSurveyBeforeProgram.component.html',
})
export class ViaSurveyBeforeProgramComponent implements OnInit {
  public viaSurveyToken: WritableSignal<string | null> = signal(null);

  public readonly PageType: typeof PageType = PageType;

  private readonly KEY_LOCAL_STORAGE_VIA_SURVEY_TOKEN: string = 'via_survey_token' as const;

  constructor(
    private localStorageService: LocalStorageService,
    private participantService: ParticipantService,
    private plRouter: PlRouter,
  ) {}

  public ngOnInit(): void {
    const url: string = this.plRouter.url;
    const urlParams: URLSearchParams = new URLSearchParams(getUrlParams(url));
    this.extractAndStoreParticipantDetailsFromUrl(urlParams);

    // setting viaSurveyToken will trigger ngOnInit() within CourseContentComponent
    // before this happens, we need to wait a cycle to make sure CourseContentService had time
    // to register the change of participant (done asynchronously via an "effect")
    // This is because changing participant reset all data in courseContentService
    setTimeout(() => {
      this.viaSurveyToken.set(this.extractTokenFromUrl(urlParams));
    }, 50);
  }

  private extractTokenFromUrl(urlParams: URLSearchParams): string | null {
    let viaSurveyToken: string | null = urlParams.get(TOKEN_SURVEY_QUERY_PARAM_KEY);
    if (viaSurveyToken) {
      this.localStorageService.storeInLocalStorage(this.KEY_LOCAL_STORAGE_VIA_SURVEY_TOKEN, viaSurveyToken);
    } else {
      viaSurveyToken = this.localStorageService.getFromLocalStorage(this.KEY_LOCAL_STORAGE_VIA_SURVEY_TOKEN);
    }

    return viaSurveyToken;
  }

  private extractAndStoreParticipantDetailsFromUrl(urlParams: URLSearchParams): void {
    const participantId: string | null = urlParams.get(ID_VIA_SURVEY_QUERY_PARAM_KEY);
    if (participantId) {
      const participantGender: ParticipantGender | null = urlParams.get(
        GENDER_VIA_SURVEY_QUERY_PARAM_KEY,
      ) as ParticipantGender;

      this.participantService.setParticipant({
        id: +participantId,
        email: '',
        username: '',
        first_name: '',
        last_name: '',
        gender: participantGender || 'o',
        cohorts: [],
      });
    }
  }
}
